module.exports = __webpack_public_path__ + "static/media/KU.41be980f.png";